/**
 * Toggle a value within an array of active values.
 * @param {Array} array The list of active values.
 * @param {String} payload The payload to toggle.
 */
export default function toggleArrayElement(array, payload) {
  if (array.includes(payload)) {
    // Remove payload from array.
    return array.filter(value => value !== payload);
  }
  // Add payload to array.
  return [...array, payload];
}
